import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/user-access';
const userAccessRightList = () => {
	return Client.get('/admin/api/user-access/access-rights');
};
const userAccessRightListCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/access-rights`);
};
const allUsers = () => {
	return Client.get('/admin/api/user-access');
};
const allUsersCloud = (merchantId, branchId) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/users`);
};
const newUser = (user) => {
	return Client.post('/admin/api/user-access', user);
};
const newUserCloud = (merchantId, branchId, user) => {
	return Client.post(`${numbatUrl}/${merchantId}/${branchId}/user`, user);
};
const userInfo = (staffName) => {
	return Client.get(`/admin/api/user-access/${staffName}`);
};
const userInfoCloud = (merchantId, branchId, staffName) => {
	return Client.get(
		`${numbatUrl}/${merchantId}/${branchId}/staffName/${staffName}`
	);
};
const updateUserInfo = (staffName, user) => {
	return Client.put(`/admin/api/user-access/${staffName}`, user);
};
const updateUserInfoCloud = (merchantId, branchId, staffName, user) => {
	return Client.put(
		`${numbatUrl}/${merchantId}/${branchId}/staffName/${staffName}`,
		user
	);
};
const removeUser = (staffName) => {
	return Client.del(`/admin/api/user-access/${staffName}`);
};
const removeUserCloud = (merchantId, branchId, staffName) => {
	return Client.del(
		`${numbatUrl}/${merchantId}/${branchId}/staffName/${staffName}`
	);
};
export default {
	userAccessRightList,
	allUsers,
	newUser,
	userInfo,
	updateUserInfo,
	removeUser,
	allUsersCloud,
	userInfoCloud,
	userAccessRightListCloud,
	updateUserInfoCloud,
	newUserCloud,
	removeUserCloud,
};
